<template>
  <v-dialog v-model="dialog" width="600px" :fullscreen="$vuetify.breakpoint.smAndDown" scrollable>
    <v-card>
      <v-card-title class="primary white--text"
        ><v-toolbar-title>{{ typeDialog === 'update' ? 'SỬA' : 'THÊM' }} CÂU HỎI</v-toolbar-title>
        <v-spacer />
        <v-icon color="white" @click="cancel">close</v-icon>
      </v-card-title>
      <v-card-text>
        <v-form ref="form" class="mt-4">
          <h3>1. Thông tin cơ bản</h3>
          <v-row class="mt-1">
            <v-col cols="12" md="6" class="pb-3">
              <v-autocomplete
                no-data-text="Chọn loại câu hỏi"
                :items="typeQuestions"
                item-text="title"
                item-value="value"
                v-model="type"
                label="Loại câu hỏi"
                outlined
                hide-details
                :rules="[$rules.required]"
                class="required ma-0"
                dense
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="12" class="pb-0">
              <v-text-field
                label="Nội dung câu hỏi"
                class="required"
                :rules="[$rules.required]"
                v-model="title"
                dense
                outlined
                required
              ></v-text-field>
            </v-col>
          </v-row>
          <div v-if="type && type !== 'text'" class="my-2">
            <h3>2. Danh sách câu trả lời</h3>
            <MultipleAnswer ref="multiple-answer" :question="question" />
          </div>
          <v-divider class="mt-5"></v-divider>
          <div class="d-flex justify-end">
            <v-switch v-model="required" hide-details="" label="Bắt buộc"></v-switch>
          </div>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="d-flex justify-space-between pa-4">
        <v-btn class="px-6" outlined light depressed @click="cancel">Huỷ</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" width="100px" class="elevation-0" @click="onSave">Xác nhận</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import { get } from 'lodash'
import MultipleAnswer from './components/QuestionDialog/MultipleAnswer.vue'
export default {
  components: { MultipleAnswer },
  data() {
    return {
      dialog: false,
      question: null,
      listAnswer: [],
      required: false,
      title: '',
      type: null,
      typeDialog: '',
      typeQuestions: [
        { title: 'Văn bản', value: 'text' },
        { title: 'Trắc nghiệm', value: 'single' },
        { title: 'Hộp kiểm', value: 'multiple' }
      ]
    }
  },

  computed: {
    ...mapState({
      survey: state => state.survey.item
    })
  },

  methods: {
    ...mapActions({
      fetch: 'surveyQuestion/fetch',
      create: 'surveyQuestion/create',
      update: 'surveyQuestion/update'
    }),
    ...mapMutations({
      setState: 'survey/setState'
    }),
    get,
    openDialog(typeDialog, item) {
      if (item) {
        this.question = item
        this.title = item.title
        this.type = item.type
        this.required = item.required
        this.listAnswer = get(item, 'listAnswer', [])
      }
      this.typeDialog = typeDialog
      this.dialog = true
    },
    cancel() {
      this.dialog = false
      this.reset()
    },
    reset() {
      this.question = null
      this.title = ''
      this.type = null
      this.required = false
      this.listAnswer = []
    },
    async onSave() {
      try {
        if (this.$refs.form.validate()) {
          this.$loading.active = true
          let data = { title: this.title, survey: this.survey.id, type: this.type, required: this.required }
          if (this.type === 'single' || this.type === 'multiple') {
            const answers = this.$refs['multiple-answer'].getData()
            if (answers === null) return
            data.answers = answers
          }
          if (this.typeDialog === 'update') await this.update({ id: this.question.id, ...data })
          else await this.create(data)
          this.$alert.success(`${this.typeDialog === 'update' ? 'Cập nhật' : 'Thêm'} thành công`)
          this.fetch({ survey: this.survey.id })
          this.cancel()
        }
      } catch (error) {
        this.$alert.error(error)
      } finally {
        this.$loading.active = false
      }
    }
  }
}
</script>
